export const firebaseConfig = {
    apiKey: "AIzaSyBHo5FyIlHc7ZxLH4yHLCRdvpjd5erPrg0",
    authDomain: "show-finder-rh.firebaseapp.com",
    projectId: "show-finder-rh",
    storageBucket: "show-finder-rh.appspot.com",
    messagingSenderId: "870549306197",
    appId: "1:870549306197:web:42c9f0717a7859b4820ddc",
    measurementId: "G-YFC19Q81NQ"
  };

export const showKeys = {
    watchmode: 'AzqK06TlZf99cqVlzhDUrivGTalYBlvgrciFtsge',
    tmdb: 'cacaf0657a4cac543400f7fbbfebe0b2'
}